import React from 'react';
import { Typography, Box, AppBar } from '@mui/material';
import images from '../../assets/images';

const Welcome = () => {
  return (
    <Box>
      <AppBar
        position="sticky"
        data-testid="welcome-top-bar"
        sx={{ width: '100%', zIndex: (theme) => theme.zIndex.drawer + 1, textAlign: 'center' }}
      >
        <Typography variant="h3" data-testid="jimbo-title">
          Jimbo
        </Typography>
      </AppBar>
      <Box data-testid="welcome-message" textAlign="center" sx={{ marginTop: 20 }}>
        <img src={images.hi} height="80" width="80" alt="Hi" data-testid="hi-image" />
        <Typography variant="h5" sx={{ fontSize: '50px' }}>
          Welcome!
        </Typography>
        <Typography>Thank you for signing up to Jimbo. An email has been sent to the admin team to set up your access.</Typography>
        <Typography>They will be in contact with you shortly.</Typography>
      </Box>
      <Box sx={{ position: 'fixed', bottom: 0, right: 0, zIndex: -100 }}>
        <img src={images.scott} alt="Scott" height="400" width="auto" data-testid="scott-image" />
      </Box>
    </Box>
  );
};

export default React.memo(Welcome);
